import { Account } from '@/api/generated'

export const Anonymous: Account = {
  email: 'anonymous@respondeco.org',
  id: -1,
  name: 'anonym',
  roles: [],
  organisation: {
    id: -1,
    categories: [],
    name: 'anonym',
  },
}
